import { render } from "./publicContents.vue?vue&type=template&id=77b2c321&scoped=true"
import script from "./publicContents.vue?vue&type=script&lang=js"
export * from "./publicContents.vue?vue&type=script&lang=js"

import "./publicContents.vue?vue&type=style&index=0&id=77b2c321&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b2c321"]])

export default __exports__